module.exports = "/_next/static/images/e7b66315c3b146d765b66c07aa8439c5-plus.svg";